import { getItemFromStorage, teamAllowsWorkQueues } from "./script"
import { retrieveAllWorkQsCleaned, teamsOptions } from "./systemData"
import { retrieveAllWorkQs } from "./systemData"

export const dashboardFunctions = {
    getUserWorkQs: function() {
        const user = getItemFromStorage('user')
        const teams = teamsOptions()
        let workqs = retrieveAllWorkQsCleaned()?.filter(item => !item.type && item.active)
        let finalUserWorkqs = {
            type: 'single',
            workqs: []
        }
        const userTeamsForWorkQueues = (user?.teams || []).filter(team => teamAllowsWorkQueues(team))
        if (user && userTeamsForWorkQueues.length) {
            if (userTeamsForWorkQueues.length == 1) { // if the user is in only one team, show all workqs for that team
                let systemTeam = teams.find(item => item.id == userTeamsForWorkQueues[0].id)

                if (systemTeam) {

                    if (systemTeam.work_queues && systemTeam.work_queues.length > 0) {
                        finalUserWorkqs.workqs = workqs.filter(item => systemTeam.work_queues.includes(item.id))
                        return finalUserWorkqs
                    } else {
                        finalUserWorkqs.workqs = null
                        return finalUserWorkqs
                    }
                    
                }
            } else {
                finalUserWorkqs.type = 'multiple'
             
                userTeamsForWorkQueues.forEach(team => {
                    let systemTeam = teams.find(item => item.id == team.id)
                    if (systemTeam) {
                        
                        if (systemTeam.work_queues && systemTeam.work_queues.length > 0) {
                            let teamWorkqs = workqs.filter(item => systemTeam.work_queues.includes(item.id))
                            finalUserWorkqs.workqs.push({label: systemTeam.name, value: systemTeam.id, workqs: teamWorkqs})
                        } else {
                        }
                    }
                })

                return finalUserWorkqs
            }
        }


        return null
    }
}